import { useEffect } from "react";
import { useLocation } from "react-router-dom-v5-compat";

export const useScrolltopOnPathChange = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
};
